module.exports = __webpack_public_path__ + "static/media/MC3.0f67cf49.jpeg";